export default __webpack_public_path__ + "static/media/review_tit_bg.6e3ec01c.png";